import { useRef, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { Button, TextField, Typography } from "@mui/material";
import Toast from "../../utils/Toast";
import LoadingCircle from "../../utils/LoadingCircle";
import { HttpMainApi } from "../../interface/main-api";
import { userState } from "../../interface/MainInterface";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const mainApi = new HttpMainApi();

interface propsType {
  userState: userState;
}

interface PasswordChangeFormProps extends propsType {
  onSuccess?: () => void;
}

export const PasswordChangeForm = ({ userState, onSuccess }: PasswordChangeFormProps) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const fncChPwd = async () => {
    if (!password) {
      toastRef.current?.toast("비밀번호를 입력하세요.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      return;
    }
    if (!password2) {
      toastRef.current?.toast("비밀번호 확인을 입력하세요.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      return;
    }
    if (password !== password2) {
      toastRef.current?.toast("비밀번호가 일치하지 않습니다.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      return;
    }

    if (!window.confirm("비밀번호를 변경 하시겠습니까?")) return;

    setIsLoading(true);
    const res = await mainApi.update_user_password({
      pk: "COMMUNITY/USER",
      sk: userState.userId,
      password: CryptoJS.SHA256(password).toString(),
    });

    if (res.code === "200") {
      setPassword("");
      setPassword2("");
      alert("비밀번호 변경이 완료되었습니다.");
      onSuccess?.();
    } else {
      alert(
        `알 수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`,
      );
    }
    setIsLoading(false);
  };

  return (
    <>
      <Stack spacing={1.5}>
        <TextField
          id="password"
          value={password}
          placeholder="비밀번호를 입력하세요"
          variant="outlined"
          label="새 비밀번호"
          fullWidth
          required
          type="password"
          autoComplete="new-password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          id="password2"
          value={password2}
          placeholder="동일한 비밀번호를 입력하세요"
          variant="outlined"
          label="새 비밀번호 확인"
          fullWidth
          required
          type="password"
          autoComplete="new-password"
          onChange={(e) => setPassword2(e.target.value)}
        />
        <Button
          variant="contained"
          fullWidth
          onClick={fncChPwd}
          sx={{ minHeight: 48, borderRadius: 2, fontWeight: 700 }}
        >
          비밀번호 변경
        </Button>
      </Stack>
      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

const MobilePassChpage = (props: propsType) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: "#f6f7fb",
        p: { xs: 2, sm: 3 },
        pt: { xs: 5, sm: 7 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: "40rem",
          mx: "auto",
          p: { xs: 2.5, sm: 3 },
          borderRadius: 3,
          border: "1px solid #e6e9f0",
        }}
      >
        <Typography variant="h6" fontWeight={800} color="#202637">
          비밀번호 변경
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, mb: 3 }}>
          안전한 서비스 이용을 위해 새 비밀번호를 설정해 주세요.
        </Typography>
        <PasswordChangeForm userState={props.userState} onSuccess={() => navigate("/mobilemain")} />
      </Paper>
    </Box>
  );
};

export default MobilePassChpage;
